import React from 'react';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import CustomButton from '../../../../../../../../../lib/designSystem/Button';

const SelectCreditLineType = (props: any) => {
  const { open, setOpen, setOpenClientDialog, setOpenStakeholderDialog } =
    props;
  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle>Selecciona el tipo de línea de crédito</DialogTitle>
      <DialogContent>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <CustomButton
            onClick={() => {
              setOpen(false);
              setOpenClientDialog(true);
            }}
          >
            Cliente
          </CustomButton>
          <CustomButton
            onClick={() => {
              setOpen(false);
              setOpenStakeholderDialog(true);
            }}
          >
            Deudor
          </CustomButton>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SelectCreditLineType;
